export default __webpack_public_path__ + "static/java-0b01ae5598a06693a618955e6113f3fa.png";